import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiListResponse, IAPCategoryReduced } from '@/_types'

export const fetchAPCategories = async (): Promise<IAPCategoryReduced[]> => {
	const response = await axios.get<ApiListResponse<IAPCategoryReduced>>(
		'v1/web/yearProgram/categories'
	)
	return response.data.data
}

export const useGetAPCategories = () => {
	return useQuery({
		queryKey: ['ap-categories'],
		queryFn: fetchAPCategories
	})
}
